import React from 'react';
import { Link } from 'react-router-dom';

import Header from '../../components/header';
import Footer from '../../components/footer';

import 'bootstrap/dist/css/bootstrap.min.css';
import './styles.css';

export default function A1() {
  return (
    <>
      <Header content="Informações Mínimas" />
      <div className="a1-container container">
        <div className="a1-content">
          <div className="row mb-5">
            <ul className="a1-list">
              <li>
                Ter em mãos o seu ticket e sua senha de identificação que foram
                fornecidos ao final da validação;
              </li>
              <li>Utilizar um computador com Windows 7 ou superior;</li>
              <li>
                Desativar o antivírus e o gerenciador de downloads (caso tenha);
              </li>
              <li>
                Utilizar um usuário no computador com permissões
                administrativas;
              </li>
            </ul>
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-6">
            <div className="row justify-content-center">
              <button type="submit" className="button-a3 btn">
                <Link to="/support">SUPORTE TÉCNICO</Link>
              </button>
            </div>
          </div>
          <div className="col-6">
            <div className="row justify-content-center">
              <button type="submit" className="button-a3 btn">
                <Link to="/tutorial">INICIAR TUTORIAL</Link>
              </button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
